import React from 'react';
import { Button, Card, Empty, Input, Space, Typography } from 'antd';
import { formatCurrency } from 'utils/number';

const { Search } = Input;
const { Text } = Typography;

const UserListMobile = ({ viewModel }) => {
  return (
    <Space direction='vertical' size={12} style={{ width: '100%' }}>
      <Card bodyStyle={{ padding: 12 }} style={{ width: '100vw' }}>
        <Search
          placeholder='Tên hoặc số điện thoại'
          onChange={(e) => viewModel.setFilterValue('info', e.target.value)}
          value={viewModel.filter.info}
          allowClear
        />
      </Card>

      <Card bodyStyle={{ padding: 12 }} style={{ width: '100vw' }}>
        <Space direction='vertical' size={10} style={{ width: '100%' }}>
          <Text type='secondary'>Tìm thấy {viewModel.data.length} cộng tác viên</Text>

          {viewModel.data.length === 0 && (
            <Empty description='Không có cộng tác viên phù hợp' image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}

          {viewModel.data.map((record) => (
            <Card key={record.id} size='small' bodyStyle={{ padding: 12 }}>
              <Space direction='vertical' size={8} style={{ width: '100%' }}>
                <div>
                  <Text strong>{record.full_name || '-'}</Text>
                  <br />
                  <Text type='secondary'>{record.phone || '-'}</Text>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                  <Text type='secondary'>Số dư hoa hồng</Text>
                  <Text>{formatCurrency(record.commission?.current_commission)}</Text>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                  <Text type='secondary'>Hoa hồng đang xử lý</Text>
                  <Text>{formatCurrency(record.commission?.pending_commission)}</Text>
                </div>

                {viewModel.canViewDetail(record) && (
                  <Button type='primary' block onClick={() => viewModel.openDetail(record)}>
                    Xử lý rút tiền
                  </Button>
                )}
              </Space>
            </Card>
          ))}
        </Space>
      </Card>
    </Space>
  );
};

export default React.memo(UserListMobile);
